import { saveAs } from 'file-saver'

/* @ngInject */
function attachmentService (
  $rootScope,
  $timeout,
  $translate,
  ConnectorWebService,
  TemporaryFileService,
  AssetService,
  Utils
) {
  var service = {
    attach: attach,
    disattach: disattach,
    formatFileName: formatFileName,
    downloadAttachment: downloadAttachment,
    downloadWithProgress: downloadWithProgress,
    generateUUID: _uuidv4
  }
  return service

  function attach (aFilesAttached, aFiles, aAttachments, fnOnChange, fnOnComplete, fnOnProgress) {
    $rootScope.getUser().then(function (oUser) {
      aFilesAttached.forEach(function (file) {
        var index = _uuidv4()
        file.percentage = 0

        var newFile = {
          id: index,
          name: file.name,
          ownerId: oUser.id,
          type: 'FILE',
          size: file.size,
          src: '',
          thumbnailSrc: '',
          defaultThumbnailSrc: '/assets/img/repository_asset_thumbs/file.png'
        }

        file.id = index
        file.userId = oUser.id
        file.uploading = true
        TemporaryFileService.uploadFile(
          file,
          _fileOnChange(aFiles, aAttachments, newFile, fnOnChange, fnOnComplete),
          fnOnProgress,
          null,
          aFiles,
          {
            uuid: index
          }
        )

        if (fnOnChange) {
          fnOnChange({
            value: aAttachments
          })
        }
      })
    })
  }

  function disattach (oRemoveAttachment, aFiles, aAttachments, fnOnChange, fnOnComplete) {
    let removedAttId
    $timeout(function () {
      aFiles = aFiles.filter(function (oAttachment) {
        var fileId
        if (typeof oRemoveAttachment === 'string' || typeof oRemoveAttachment === 'number') {
          fileId = oRemoveAttachment
        } else if (!oRemoveAttachment.uploading && oAttachment.id && oAttachment.id === oRemoveAttachment.id) {
          fileId = oRemoveAttachment.id
        }

        if (fileId && oAttachment.id !== fileId) {
          return true
        } else if (oAttachment.id === fileId) {
          if (oAttachment.req && oAttachment.req.length) {
            oAttachment.req[0].req().abort()
          }

          const existsEmbedded = aAttachments.find(attachment => attachment.isEmbedded)
          const spliceIndex = existsEmbedded
            ? aAttachments.findIndex(a => a.id === oAttachment.id)
            : aAttachments.indexOf(oAttachment.id)

          if (spliceIndex >= 0) {
            aAttachments.splice(spliceIndex, 1)
          }
          removedAttId = fileId
          return false
        }
      })

      if (fnOnChange) {
        fnOnChange({
          value: aAttachments
        })
      }

      if (fnOnComplete) {
        fnOnComplete(removedAttId)
      }
    }, 100)
  }

  function formatFileName (oAttachment) {
    var fileExtension = ''

    if (oAttachment.extension || oAttachment.contentType) {
      fileExtension = '.' + oAttachment.extension || Utils.beautifyContentTypes(oAttachment.contentType)
    }

    if (oAttachment.name) {
      return oAttachment.name + fileExtension
    } else {
      return $translate.instant('noTitle') + fileExtension
    }
  }

  function downloadAttachment (attachment, sUrl) {
    return new Promise(resolve => {
      ConnectorWebService.createCustomXHR(
        sUrl,
        'GET',
        null,
        { responseType: 'blob' },
        {
          load: () => {
            return function () {
              const blob = this.response
              saveAs(blob, formatFileName(attachment))
              resolve()
            }
          }
        }
      )
    })
  }

  function downloadWithProgress (sId, progressCallback, callback, sUrl, options) {
    sUrl = Utils.fnReplaceStringParams(sUrl, [sId])

    if (options && options.query) {
      sUrl = Utils.fnAddQueryToUrl(sUrl, options.query)
    }

    return ConnectorWebService.createCustomXHR(
      sUrl,
      'GET',
      null,
      { responseType: 'blob' },
      {
        load: () => {
          return function () {
            callback(this.response)
          }
        },
        progress: progressCallback
      },
      options
    )
  }

  function _fileOnChange (aFiles, aAttachments, oAttachment, fnOnChange, fnOnComplete) {
    return function onChange (response) {
      var uploadedFile = response.data[0]

      var index = _findUploadingFileIndex(aFiles, oAttachment)

      if (index === false) {
        if (fnOnChange) {
          fnOnChange({
            value: aAttachments
          })
        }
        return
      }

      const existsEmbedded = aAttachments.find(attachment => attachment.isEmbedded)

      if (existsEmbedded) {
        aAttachments.push({ id: uploadedFile.uuid, isEmbedded: false })
      } else {
        aAttachments.push(uploadedFile.uuid)
      }

      oAttachment.id = uploadedFile.uuid
      oAttachment.ownerId = uploadedFile.ownerId
      oAttachment.defaultThumbnailSrc = AssetService.getAssetThumbnailByType(uploadedFile)
      oAttachment.src = ''
      oAttachment.type = uploadedFile.type
      oAttachment.extension = uploadedFile.extension
      oAttachment.hasThumbnail = uploadedFile.hasThumbnail

      aFiles[index] = oAttachment

      if (fnOnChange) {
        fnOnChange({
          value: aAttachments
        })
      }

      const attachmentsLength = existsEmbedded
        ? aAttachments.filter(attachment => !attachment.isEmbedded).length
        : aAttachments.length

      if (attachmentsLength !== aFiles.length) {
        return
      }

      if (fnOnComplete) {
        fnOnComplete(oAttachment)
      }
    }
  }

  function _findUploadingFileIndex (aFile, oFile) {
    var index = false
    aFile.forEach(function (oItem, i) {
      if (oItem.id === oFile.id) {
        index = i
      }
    })
    return index
  }

  function _uuidv4 () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
      return (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    })
  }
}

export { attachmentService }
